// Shared client-side rules for chat file sharing. The server re-validates all
// of this (UploadRules::chatFile + StorageQuota); this is just fast feedback.

export const MAX_FILES = 4;
export const MAX_SIZE = 2 * 1024 * 1024; // 2 MB per file

export const ALLOWED_EXT = [
  "jpg", "jpeg", "png", "gif", "webp",
  "pdf", "doc", "docx", "ppt", "pptx", "xls", "xlsx", "csv",
];
export const IMAGE_EXT = ["jpg", "jpeg", "png", "gif", "webp"];

// Explicit types (no image/* — that would let svg through, which we don't allow).
export const ACCEPT = "image/jpeg,image/png,image/gif,image/webp,.pdf,.doc,.docx,.ppt,.pptx,.xls,.xlsx,.csv";

export function extOf(name = "") {
  const i = name.lastIndexOf(".");
  return i >= 0 ? name.slice(i + 1).toLowerCase() : "";
}

export function isImageFile(file) {
  return (file.type || "").startsWith("image/") || IMAGE_EXT.includes(extOf(file.name));
}

export function formatBytes(bytes = 0) {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(0)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}

/**
 * Filter a dropped/picked FileList against the type, size, and count caps.
 * Returns { accepted: File[], errors: string[] }. `existingCount` is how many
 * files are already staged so the 5-file cap is enforced across both.
 */
export function validateFiles(fileList, existingCount = 0) {
  const errors = [];
  const accepted = [];
  let slots = Math.max(0, MAX_FILES - existingCount);

  for (const file of Array.from(fileList || [])) {
    if (!ALLOWED_EXT.includes(extOf(file.name))) {
      errors.push(`${file.name}: unsupported type`);
      continue;
    }
    if (file.size > MAX_SIZE) {
      errors.push(`${file.name}: over 2 MB`);
      continue;
    }
    if (slots <= 0) {
      errors.push(`Only ${MAX_FILES} files at a time`);
      break;
    }
    accepted.push(file);
    slots -= 1;
  }

  return { accepted, errors };
}
